<template>
  <v-card>
    <v-card-text>
      <v-row align="center" justify="center">
        <v-col>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" xl="2" sm="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                block
                @click="changeAction(2)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left> mdi-plus </v-icon> Nuevo parametro
              </v-btn>
            </template>
            <span>Agregar parametro</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :items-per-page="10"
        :footer-props="{
          'items-per-page-text': 'Elementos por página',
          'items-per-page-all-text': 'Todo',
        }"
        no-results-text="Sin resultados coincidentes con el búsqueda"
        no-data-text="Sin resultados disponibles"
        dense
        fixed-header
        height="auto"
        class="mt-5"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top v-if="$utilFront.withPermission($prm.MODULE_CONF)" color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon x-small @click="get(item)">
                <v-icon color="blue" v-bind="attrs" v-on="on">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            <small>Editar</small>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "ParameterTable",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
    headers: {
      type: Array,
      default: () => [],
    },
    changeAction: {
      type: Function,
    },
    get: {
      type: Function,
    },
  },
};
</script>
